module.exports = __webpack_public_path__ + "img/webhock.a2f84618.svg";